module.exports = __webpack_public_path__ + "img/bulls___apes_-_calendar_august_22-28__1_.50be02d1.jpg";